import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

export class NotaOperacaoGarantida extends BaseEntity {
    idOperacao:number;
    idAgenteFinanceiro:number;
    idOperacaoExterno: string;
    sistemaRepasse:string;
    contratoRepasse:string; 
    mensagem:string;
    ativo:string;
    dataEnvio: string;
    nomeUsuarioEnvio: string;
    nomeUsuarioUltimaAtualizacao: string;
    nomeAnexo:string;
}

export const TIPO_CLASSE_OPERACAO =[
    {
        codigo: 'CL',
        nome:"CL - Credito Livre"
    },
    {
        codigo: '15',
        nome:"15 - FINAME",
    },
    {
        codigo: '89',
        nome:"89 - BNDES"
    },

]

export const ESTADO_NOTA = [
    {
        valor:'S',
        descricao:'Ativo'
    },
    {
        valor:'N',
        descricao:'Excluido'
    }
];